// @flow

import * as React from "react";
import { useDispatch } from "react-redux";

import actions from "../actions";

const useNoNav = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(actions.setNoNav());

        return function cleanup() {
            dispatch(actions.unsetNoNav());
        };
    }, []); //eslint-disable-line
};

export default useNoNav;
